module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    attrs: {
      "grid": true,
      "alignTop": true
    }
  }, [_c('Select', {
    attrs: {
      "label": "Гражданство",
      "name": "citizenship",
      "placeholder": "Введите название страны",
      "v": _vm.$v.user.citizenship,
      "options": _vm.citizenshipDict,
      "filterable": true
    },
    model: {
      value: (_vm.user.citizenship),
      callback: function($$v) {
        _vm.$set(_vm.user, "citizenship", $$v)
      },
      expression: "user.citizenship"
    }
  }), _c('AppCheckBox', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "input": _vm.user.is_russian_work_permission,
      "name": "is_russian_work_permission"
    },
    model: {
      value: (_vm.user.is_russian_work_permission),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_russian_work_permission", $$v)
      },
      expression: "user.is_russian_work_permission"
    }
  }, [_vm._v("Разрешение на работу в Российской Федерации")]), _c('Select', {
    attrs: {
      "label": "Регион",
      "name": "region_id",
      "placeholder": "Выберите регион",
      "v": _vm.$v.user.region_id,
      "options": _vm.regionsDict
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.municipality_id.$touch()
      }
    },
    model: {
      value: (_vm.user.region_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "region_id", $$v)
      },
      expression: "user.region_id"
    }
  }), (_vm.isMunicipality) ? _c('Select', {
    class: {
      'mb-10': _vm.$v.user.municipality_id.$invalid
    },
    attrs: {
      "label": "Муниципалитет",
      "name": "municipality_id",
      "placeholder": "Выберите муниципалитет",
      "v": _vm.$v.user.municipality_id,
      "disabled": _vm.isDisableMunicipality,
      "error-text": "Введите муниципалитет",
      "options": _vm.municipalitiesOptions,
      "readonly": _vm.isDisableMunicipality
    },
    model: {
      value: (_vm.user.municipality_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "municipality_id", $$v)
      },
      expression: "user.municipality_id"
    }
  }) : _vm._e(), _c('Select', {
    attrs: {
      "placeholder": "Введите адрес регистрации",
      "label": "Адрес регистрации по месту жительства",
      "v": _vm.$v.user.address,
      "options": _vm.addressOptions,
      "filterable": true,
      "asyncSearch": true,
      "clearable": true,
      "default-value": ""
    },
    on: {
      "filter": _vm.searchAddress
    },
    model: {
      value: (_vm.user.address),
      callback: function($$v) {
        _vm.$set(_vm.user, "address", $$v)
      },
      expression: "user.address"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите индекс",
      "label": "Индекс по месту регистрации",
      "maxlength": "6",
      "v": _vm.$v.user.zip_code,
      "error-text": "Неверный формат индекса"
    },
    model: {
      value: (_vm.user.zip_code),
      callback: function($$v) {
        _vm.$set(_vm.user, "zip_code", $$v)
      },
      expression: "user.zip_code"
    }
  }), _c('AppCheckBox', {
    attrs: {
      "input": _vm.user.address_match,
      "name": "address_match"
    },
    model: {
      value: (_vm.user.address_match),
      callback: function($$v) {
        _vm.$set(_vm.user, "address_match", $$v)
      },
      expression: "user.address_match"
    }
  }, [_vm._v("Совпадает с адресом регистрации")]), _c('br'), (!_vm.user.address_match) ? [_c('FormInput', {
    attrs: {
      "placeholder": "Введите адрес проживания",
      "label": "Адрес проживания",
      "v": _vm.$v.user.residence_registration_match,
      "error-text": _vm.getError(_vm.$v.user.residence_registration_match, {
        field: "адреса",
        minLength: "минимальная длина 3 символа"
      })
    },
    model: {
      value: (_vm.user.residence_registration_match),
      callback: function($$v) {
        _vm.$set(_vm.user, "residence_registration_match", $$v)
      },
      expression: "user.residence_registration_match"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите индекс",
      "label": "Индекс по месту проживания",
      "required": !_vm.user.address_match,
      "maxlength": "6",
      "v": _vm.$v.user.address_zip,
      "error-text": _vm.getError(_vm.$v.user.address_zip, {
        field: "индекса",
        minLength: "минимальная длина 6 символов",
        numeric: "индекс состоит из цифр"
      })
    },
    model: {
      value: (_vm.user.address_zip),
      callback: function($$v) {
        _vm.$set(_vm.user, "address_zip", $$v)
      },
      expression: "user.address_zip"
    }
  })] : _vm._e(), _c('div', {
    staticClass: "saveblock"
  }, [_c('Message', {
    attrs: {
      "accent": _vm.correctUpdateProfile,
      "bottom": true,
      "color": _vm.color
    }
  }, [_vm._v(_vm._s(_vm.text))]), _c('Button', {
    attrs: {
      "disabled": !_vm.changed && !_vm.isMunicipalityNotEmpty,
      "isLoading": _vm.isLoading
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить изменения")])], 1), _c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Отменить изменения")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0e659a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/address/AddressSettings.vue
// module id = ece825ccada662aab311
// module chunks = 29